<script setup lang="ts">

import CommonFieldIds from "@/utils/constants/CommonFieldIds.ts";
import EditViewUtils from "@/utils/editView/EditViewUtils.ts";
import NaMaMainFileWidget from "@/components/EditView/widgets/NaMaMainFileWidget.vue";
import {BlockProps} from "@/utils/presenters/interfaces.ts";
import InputWidgetsGroup from "@/components/EditView/editScreens/InputWidgetsGroup.vue";

const props = defineProps<BlockProps>();

</script>

<template>
  <div
    class="tw-flex tw-flex-wrap tw-gap-x-[2%] compact:tw-gap-x-[1%] ultra:tw-gap-x-[0.5%] quad:compact:tw-gap-x-[0.5%] quad:ultra:tw-gap-x-[0.25%] horizontal:tw-gap-x-[0%] tw-items-center">
    <div style="text-align: -webkit-center;"
         class="tw-place-self-start tw-mb-2 tw-w-[29%]  mobile:tw-min-w-[99%] quad:compact:tw-w-[29.5%] quad:ultra:tw-w-[29.5%] compact:tw-mb-0.5 ultra:tw-mb-0 compact:tw-w-[29.5%] ultra:tw-w-[29.5%] horizontal:tw-w-[30%] tw-h-full">
      <NaMaMainFileWidget :field="{id:CommonFieldIds.MAIN_FILE}" :isInsideComposite="true" :presenter="presenter"
                          :fieldMetaData="EditViewUtils.getFieldMetaData(presenter.metadata, CommonFieldIds.MAIN_FILE)!" :isSpanned="false"/>
    </div>
    <div class=" tw-mb-2 mobile:tw-min-w-[99%] compact:tw-mb-0.5 ultra:tw-mb-0 tw-w-[69%] quad:compact:tw-w-[69.5%] quad:ultra:tw-w-[69.5%] compact:tw-w-[69.5%] ultra:tw-w-[69.5%] horizontal:tw-w-[70%]">
      <InputWidgetsGroup :block="block" :blockIndex="blockIndex" :presenter="presenter" :pageIndex="pageIndex" :collapsed="collapsed"
                         @navigateToNext="(args)=>$emit('navigateToNext', args)"/>
    </div>
  </div>
</template>

<style scoped>

</style>
